import React from 'react';

export default function AuthHero() {
  return (
    <div
      className="relative h-40 bg-cover bg-center"
      style={{ backgroundImage: `url('https://images.unsplash.com/photo-1761286753703-570ed91dd90e?crop=entropy&cs=srgb&fm=jpg&q=85')` }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/70 to-emerald-600/50"></div>
      <div className="relative h-full flex flex-col justify-end p-6 text-white">
        <h1 className="text-5xl font-black font-heading uppercase italic tracking-tight">SmashZone</h1>
        <p className="text-lg font-medium mt-2 text-white/90">Book Your Game, Own The Court</p>
      </div>
    </div>
  );
}
